import { render, staticRenderFns } from "./GuideHome.vue?vue&type=template&id=652c493e&scoped=true"
import script from "./GuideHome.vue?vue&type=script&setup=true&lang=ts"
export * from "./GuideHome.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GuideHome.vue?vue&type=style&index=0&id=652c493e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652c493e",
  null
  
)

export default component.exports